export class Fichier {
    public nom = '';
    public listeFichier: Array<Fichier> = [] ;
    public listeRepertoire: Array<Fichier> = [] ;
    public listeSimpleFichier: Array<Fichier> = [] ;
    public isRepertoire: Boolean = false;
    public expanded = false;
    public checked = false;
    public peuxEtreSupprime: Boolean = false;



    public static  BuildListeSimpleFichier (fichierParent: Fichier ): Array<Fichier> {
        return fichierParent.listeFichier.filter(fichier => fichier.isRepertoire == false) ;
    }

    public static  BuildListeRepertoires(fichierParent: Fichier ): Array<Fichier> {
        return fichierParent.listeFichier.filter(fichier => fichier.isRepertoire == true);
    }

    public static   creeFichier(fichierJson: Fichier): Fichier {
        let newFichier: Fichier = null;
        if (fichierJson != null ) {
            newFichier = new Fichier();
            newFichier.nom = fichierJson.nom;
            newFichier.isRepertoire = fichierJson.isRepertoire;

            newFichier.listeRepertoire = [];
            if (fichierJson.listeFichier != null && fichierJson.listeFichier.length > 0) {
                fichierJson.listeFichier.forEach(fichierFils => newFichier.listeFichier.push(Fichier.creeFichier(fichierFils)));
                newFichier.listeRepertoire = Fichier.BuildListeRepertoires(newFichier);
                newFichier.listeSimpleFichier = Fichier.BuildListeSimpleFichier(newFichier);
            }
        }
        return newFichier ;
    }

    toggle() {
        this.expanded = !this.expanded;
    }

    // noinspection JSUnusedGlobalSymbols
    checkRepertoire() {
        this.checked = !this.checked;
        this.checkRecursive(this.checked);
    }

    check(): any {
        this.checked = !this.checked;
     }

    checkRecursive(state) {
        this.listeFichier.forEach(d => {
            d.checked = state;
            d.checkRecursive(state);
        });
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/archive/fichier.model.ts